<template>
  <div id="app">
    <div v-if="$route.meta.showNavigation">
      <Navbar />
    </div>
    <router-view />
  </div>
</template>

<script>
import Navbar from '@/components/shared/Navbar.vue'
export default {
  components: {
    Navbar
  }
}
</script>

<style lang="scss"></style>
